import React from 'react';

import DocumentTitle from '@Components/DocumentTitle/DocumentTitle';
import Container from '@Components/layout/Container';
import Layout, { LayoutBackgrounds } from '@Components/layout/Layout';
import Row from '@Components/layout/Row';
import GeneralOrderFormContainer from '@Components/Order/GeneralOrder';
import PageHeader from '@Components/Page/PageHeader';
import PageTitle from '@Components/Page/PageTitle';
import Paper, { PaperDepth, PaperWidth } from '@Components/Paper';
import PaperBody from '@Components/PaperBody';
import { useTranslations } from '@Hooks/useTranslations';

import styles from './CreateGeneralOrderPage.module.scss';

const CreateGeneralOrderPage = () => {
  const t = useTranslations();

  return (
    <DocumentTitle title={t('msg_create_preliminary_order')}>
      <Layout background={LayoutBackgrounds.grayBackground} noTopPadding>
        <PageHeader>
          <Row column className={styles.title}>
            <PageTitle msg={t('msg_create_preliminary_order')} color="primary" />
          </Row>
        </PageHeader>

        <Container className={styles.formContainer}>
          <Paper width={PaperWidth.m} depth={PaperDepth.one}>
            <PaperBody>
              <GeneralOrderFormContainer />
            </PaperBody>
          </Paper>
        </Container>
      </Layout>
    </DocumentTitle>
  );
};

export default CreateGeneralOrderPage;
